import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { NotificationService } from 'app/_services/notification.service';
import { SiteService } from 'app/_services/site.service';
import { RestrictionsType } from 'app/_models/restrictions/restrictions-type';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-site-restrictions',
  templateUrl: './site-restrictions.component.html',
})
export class SiteRestrictionsComponent implements OnInit {
  public selectedSite: any;
  private selectedSiteId: any;

  public isAddRestrictionModalShown = false;
  public addSiteRestrictionForm: FormGroup;
  public isSaving = false; // helps prevent double click submit
  public restrictionType: { label: string; value: RestrictionsType  }[] = [
    { label: 'Operational', value: RestrictionsType.Operational },
    { label: 'Health & Safety', value: RestrictionsType.HealthSafety },
    { label: 'General', value: RestrictionsType.General },
  ];

  constructor(
    private siteService: SiteService,
    public notificationService: NotificationService,
    activatedRoute: ActivatedRoute,
    fb: FormBuilder,
  ) {
    activatedRoute.params.subscribe((params: Params) => {
      this.selectedSiteId = params.id;
    });

    this.addSiteRestrictionForm = fb.group({
      description: new FormControl('', Validators.required),
      type: new FormControl('', Validators.required),
    });
  }

  ngOnInit() {
    this.getSelectedSite(this.selectedSiteId);
  }

  public getSelectedSite(siteId) {
    this.siteService.getSiteById(siteId).subscribe((data: any) => {
      this.selectedSite = data;
    });
  }

  public removeRestriction(restrictionId) {
    Swal.fire({
      title: 'Remove Site Restriction?',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, remove it!',
    }).then((result) => {
      if (result.value) {
        this.siteService.removeSiteRestriction(restrictionId).subscribe(result => {
          this.getSelectedSite(this.selectedSiteId);
        });
        Swal.fire('Success', 'Site Restriction Removed!', 'success');
      }
    });
  }

  // Add a new restriction
  public showAddRestrictionModal() {
    this.addSiteRestrictionForm.reset();
    this.isAddRestrictionModalShown = true;
  }

  public async onAddSiteRestrictionFormSubmit() {
    this.isSaving = true;

    const restriction = {
      description: this.addSiteRestrictionForm.value.description,
      type: this.addSiteRestrictionForm.value.type.value,
      siteId: this.selectedSiteId,
    };

    this.siteService.addSiteRestriction(restriction).subscribe(() => {
      this.isSaving = false;
      this.isAddRestrictionModalShown = false;
      this.getSelectedSite(this.selectedSiteId);
      this.notificationService.notify('success', 'Success', 'New Site Restriction Added');
    });
  }

}
